import { useState, type FormEvent } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { PASSWORD_MIN } from '@sp/shared'
import { useSession } from '../session.tsx'
import { errorMessage } from '../lib/useResource.ts'
import { Button, Card, PageTitle, Paragraph } from '../components/ui.tsx'
import { Brand, PasswordField } from '../components/bits.tsx'

/** Odkaz na nove heslo vytvari spravce prikazem `cli.js reset <e-mail>`. */
export function ResetPasswordPage() {
  const { token = '' } = useParams<{ token: string }>()
  const session = useSession()
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit(e: FormEvent) {
    e.preventDefault()
    if (password.length < PASSWORD_MIN) {
      setError(`Heslo musí mít aspoň ${PASSWORD_MIN} znaků`)
      return
    }
    setBusy(true)
    setError(null)
    try {
      await session.resetPassword(token, password)
      navigate('/', { replace: true })
    } catch (err) {
      setError(errorMessage(err))
      setBusy(false)
    }
  }

  return (
    <div className="app-shell">
      <div className="page">
        <main className="page-content auth-page">
          <Brand />
          <PageTitle title="Nové heslo" size="hero" />
          <Paragraph>Po uložení se odhlásí všechna ostatní zařízení.</Paragraph>
          <Card>
            <form className="stack" onSubmit={(e) => void submit(e)}>
              <PasswordField
                label="Nové heslo"
                hint={`Aspoň ${PASSWORD_MIN} znaků`}
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoFocus
              />
              {error && <Paragraph tone="error">{error}</Paragraph>}
              <Button kind="primary" type="submit" full disabled={busy}>
                Uložit heslo
              </Button>
            </form>
          </Card>
        </main>
      </div>
    </div>
  )
}
